import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "transferencia-error",
  templateUrl: "./transferencia-error.component.html",
  styleUrls: ["./transferencia-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class TransferenciaErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsTransfer: string[] = [
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "operationTypeId",
    "operationValue",
    "receiverDocument",
    "receiverName",
    "receiverBank",
    "receiverBranch",
    "receiverAccount",
    "annotations",
  ];

  ngOnInit(): void {}
}
